;(function () {
  const datatable = require('datatables.net-dt')

  const moveFilter = (tableEl) => {
    const wrapper = tableEl.closest('.dataTables_wrapper')
    const filter = wrapper?.querySelector('.dataTables_filter')
    const xInitContainer = tableEl.closest('[x-init]')
    const parentContainer = xInitContainer?.parentElement

    if (filter && parentContainer?.querySelector('.table-actions-button')) {
      filter.classList.add('dataTables_filter--hoisted')
      parentContainer.insertBefore(filter, xInitContainer)
    }
  }

  const init = (bPaginate = true) => {
    document.querySelectorAll('.dataTables_filter--hoisted').forEach(el => el.remove())

    new datatable('.js-data-table', {
      bDestroy: true,
      processing: true,
      lengthChange: false,
      ordering: true,
      language: { search: '', searchPlaceholder: 'Search...' },
      bFilter: true,
      bPaginate: bPaginate,
      initComplete: function (settings) {
        moveFilter(settings.nTable)
      },
    })
  }

  const DataTable = { init }

  if (typeof window !== 'undefined') {
    window.DataTable = DataTable
  }

  return DataTable
})()
